import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'
import { useLinkProps } from '../../hooks/useLinkProps'

export type LinkProps = {
  // Allow the to prop in case the consumer is using react-router, but don't
  // allow it to be used with the href prop.
  to?: string
} & SwashbuckleComponentProps<ChakraLinkProps>

export const Link = (props: LinkProps) => {
  const linkProps = useLinkProps(props)

  return <ChakraLink {...linkProps} />
}
